import { Button as Container } from './Button';
import { ButtonIcon } from './ButtonIcon';
import { ButtonText } from './ButtonText';

type Button = typeof Container & { Icon: typeof ButtonIcon; Text: typeof ButtonText };
export const Button = Container as Button;
Button.Icon = ButtonIcon;
Button.Text = ButtonText;
